import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import {
    Droit,
    DroitCreateInput,
    DroitFilters,
    DroitListResponse,
    DroitResponse,
    DroitSelectOption,
    DroitUpdateInput,
} from '../types/droit';
import { BaseApiService } from './base-api.service';

export class DroitService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.DROITS.BASE, axios);
  }

  async getDroits(filters: DroitFilters = {}): Promise<DroitListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Droit>({ page, limit, ...rest });
  }

  async getDroitById(id: number): Promise<DroitResponse> {
    return this.get<DroitResponse>(`/${id}`);
  }

  async createDroit(data: DroitCreateInput): Promise<DroitResponse> {
    return this.post<DroitResponse, DroitCreateInput>('', data);
  }

  async updateDroit(id: number, data: DroitUpdateInput): Promise<DroitResponse> {
    return this.put<DroitResponse, DroitUpdateInput>(`/${id}`, data);
  }

  async deleteDroit(id: number): Promise<DroitResponse> {
    return this.delete<DroitResponse>(`/${id}`);
  }

  async getDroitOptions(): Promise<DroitSelectOption[]> {
    return this.get<DroitSelectOption[]>('/select');
  }
}
